import { Component, ElementRef, ViewChild, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { IconComponent } from '../icon/icon.component';
import { ThemeToggleComponent } from '../theme-toggle/theme-toggle.component';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { TranslatePipe } from '../../../core/pipes/translate.pipe';
import { ClosePanelDirective } from '../../../core/directives/close-panel.directive';

@Component({
  selector: 'demo-header',
  standalone: true,
  imports: [
    RouterLink,
    IconComponent,
    ThemeToggleComponent,
    LanguageSwitcherComponent,
    TranslatePipe,
    ClosePanelDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  readonly menuOpen = signal(false);

  @ViewChild('menuButton') menuButtonRef?: ElementRef<HTMLButtonElement>;

  get menuButtonEl(): HTMLElement | null {
    return this.menuButtonRef?.nativeElement ?? null;
  }

  toggleMenu(): void {
    this.menuOpen.set(!this.menuOpen());
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }
}
